module.exports = __webpack_public_path__ + "static/media/hidraulica.8322c225.jpeg";